
export function getAppShellMain(): HTMLElement | null {
  if (typeof document === 'undefined') return null;
  const el = document.querySelector('main');
  return el instanceof HTMLElement ? el : null;
}

export function restoreAppShellMainScrollTop(y: number): void {
  const main = getAppShellMain();
  if (!main) return;
  const apply = () => {
    main.scrollTop = y;
  };
  requestAnimationFrame(() => {
    apply();
    requestAnimationFrame(apply);
  });
}
